<template>
  <div class="d-pickup-filters">
    <pickup-filters-actions
      :value="value"
      @input="onInput"
      @click="isOpenFilters = true"
    />

    <transition
      name="fade"
      @after-enter="isOpened = true"
      @leave="isOpened = false"
    >
      <pickup-filters-list
        v-if="isOpenFilters"
        v-click-outside="onClickOutside"
        :value="value"
        @input="onInput"
        class="d-pickup-filters__filters"
      />
    </transition>
  </div>
</template>

<script>
import PickupFiltersActions from '@/components/checkout/delivery-selector/pickup-filters/pickup-filters-actions.vue';
import PickupFiltersList from '@/components/checkout/delivery-selector/pickup-filters/pickup-filters-list.vue';

export default {
  name: 'd-pickup-filters',

  components: {
    PickupFiltersList,
    PickupFiltersActions,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isOpenFilters: false,
    isOpened: false, // состояние после открытия (кейс с самозакрытием на click-outside)
  }),

  methods: {
    onInput(value) {
      this.$emit('input', value);
    },

    onClickOutside() {
      if (this.isOpened) this.isOpenFilters = false;
    },
  },
};
</script>

<style lang="scss">
.d-pickup-filters {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__filters {
    height: 223px;
    padding: 16px 6px 23px;
    margin-top: 10px;
    background: $white;
    border: 1px solid $gray_lu2;
    border-radius: 4px;
  }
}
</style>
